import { driver } from '@leagueplatform/masonry';
import {
  MASONRY_NAMESPACES,
  MASONRY_WIDGET_TYPES,
  MASONRY_ACTION_TYPES,
} from 'common/constants/masonry';
import { AuthorizationCard } from 'components/prior-authorization-status/renderers/authorization-card.component';
import { AuthorizationDetailsHeader } from 'components/prior-authorization-status/renderers/authorization-details-header.component';
import { AuthorizationServiceCard } from 'components/prior-authorization-status/renderers/authorization-service-card.component';
import { AuthorizationServiceInfoSection } from 'components/prior-authorization-status/renderers/authorization-service-info-section.component';
import { AuthorizationDetailsButton } from 'components/prior-authorization-status/renderers/authorization-details-button.component';
import {
  setPageActionHandler,
  PaginationLayout,
} from 'components/masonry-renderers/pagination-layout.renderer';
import { LearnMoreDescription } from 'components/prior-authorization-status/renderers/learn-more-status-definition.component';
import { LearnMoreText } from 'components/prior-authorization-status/renderers/learn-more-text.component';
import { LearnMoreHeader } from 'components/masonry-renderers/learn-more-header.component';
import { LearnMoreActionLink } from 'components/masonry-renderers/learn-more-action-link.component';
import { LearnMoreAccordion } from 'components/prior-authorization-status/renderers/learn-more-accordion.component';
import { AuthorizationEmptyState } from 'components/prior-authorization-status/renderers/authorization-empty-state.component';

export const initPriorAuthorizationStatusRegistry = () => {
  // STATUS PAGE
  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.AUTHORIZATION.CARD,
    MASONRY_NAMESPACES.PRIOR_AUTHORIZATIONS_STATUS,
    AuthorizationCard,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.AUTHORIZATION.LEARN_MORE.CARD,
    MASONRY_NAMESPACES.PRIOR_AUTHORIZATIONS_STATUS,
    LearnMoreActionLink,
  );

  // Use default container spinner
  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.CONTAINER_SPINNER,
    MASONRY_NAMESPACES.PRIOR_AUTHORIZATIONS_STATUS,
    driver.nodeRendererRegistry.nodeRenderers.default.containerSpinner,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.AUTHORIZATION.LEARN_MORE.HEADER,
    MASONRY_NAMESPACES.DEFAULT,
    LearnMoreHeader,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.AUTHORIZATION.LEARN_MORE.DEFINITION,
    MASONRY_NAMESPACES.PRIOR_AUTHORIZATIONS_STATUS,
    LearnMoreDescription,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.RICH_TEXT,
    MASONRY_NAMESPACES.DEFAULT,
    LearnMoreText,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.AUTHORIZATION.LEARN_MORE.STACK,
    MASONRY_NAMESPACES.DEFAULT,
    LearnMoreAccordion,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.PAGINATION_LAYOUT,
    MASONRY_NAMESPACES.PRIOR_AUTHORIZATIONS_STATUS,
    PaginationLayout,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.AUTHORIZATION.EMPTY_STATE,
    MASONRY_NAMESPACES.PRIOR_AUTHORIZATIONS_STATUS,
    AuthorizationEmptyState,
  );

  driver.actionController.registerHandler(
    MASONRY_ACTION_TYPES.DEEPLINK,
    MASONRY_NAMESPACES.PRIOR_AUTHORIZATIONS_STATUS,
    () => {},
  );

  driver.actionController.registerHandler(
    'setPage',
    MASONRY_NAMESPACES.PRIOR_AUTHORIZATIONS_STATUS,
    setPageActionHandler,
  );

  // DETAILS PAGE
  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.AUTHORIZATION.DETAILS_HEADER,
    MASONRY_NAMESPACES.PRIOR_AUTHORIZATION_STATUS_DETAILS,
    AuthorizationDetailsHeader,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.AUTHORIZATION.SERVICE.CARD,
    MASONRY_NAMESPACES.PRIOR_AUTHORIZATION_STATUS_DETAILS,
    AuthorizationServiceCard,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.AUTHORIZATION.SERVICE.INFO_SECTION,
    MASONRY_NAMESPACES.PRIOR_AUTHORIZATION_STATUS_DETAILS,
    AuthorizationServiceInfoSection,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.BUTTON,
    MASONRY_NAMESPACES.PRIOR_AUTHORIZATION_STATUS_DETAILS,
    AuthorizationDetailsButton,
  );
};
